var _defineProperty = require("/codebuild/output/src1871403156/src/node_modules/@babel/runtime/helpers/defineProperty.js");

require("core-js/modules/es.array.reduce.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('../../utility'),
    getSessionId = _require.getSessionId,
    getUserId = _require.getUserId;

var pageTypes = ["Home", "Showroom", "Model Showroom", "Brochure", "Trade In", "Vehicle Listing", "Vehicle Details", "Test Drive", "Dealer Specials", "OEM Incentives", "Service Specials", "Finance", "Service", "Schedule Service", "Tire Store", "Parts", "Accessories", "Apparel", "About Us", "Hours & Directions", "Contact Us", "Custom Dealer Content", "Page Not Found", "Blog", "Other"]; //GET DATA ELEMENT BY ID

function getValueById(id) {
  var element = document.querySelector("data[id=\"".concat(id, "\"]"));
  return element ? element.value : "";
} //GET CLICK TO CALL DEPARTMENT


function getClickToCallDepartment(anchor, number) {
  try {
    // Get department from data attribute
    if (anchor.dataset.department) {
      return anchor.dataset.department;
    } // Get hash list from local storage


    var hashListKey;

    for (var i = 0; i < localStorage.length; i++) {
      var currentKey = localStorage.key(i);

      if (currentKey.startsWith("hashList")) {
        hashListKey = currentKey;
      }
    } // Get department from hash list


    if (hashListKey) {
      var data = JSON.parse(localStorage.getItem(hashListKey));

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.mainPhoneNumber && item.mainPhoneNumber.replace(/-/g, '').replace(/\s/g, '') === number) {
            return 'sales';
          }

          if (item.serviceDepartment && item.serviceDepartment.replace(/-/g, '').replace(/\s/g, '') === number) {
            return 'service';
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // Default to sales


    return 'sales';
  } catch (err) {
    console.log(err);
    return 'sales';
  }
} //HANDLE SDB SESSION


function MaseratiSDBSession() {
  var sd = window.sd ? window.sd : undefined;
  var dealerCode = getValueById("dealerCode");

  if (sd && dealerCode) {
    var sdInit = sessionStorage.getItem('sdInit');

    if (!sdInit) {
      console.log('Initializing sd...');
      sd('create', 'MASERATI', dealerCode, 'MXS');
      sessionStorage.setItem('sdInit', true);
    } // Remove sd session on page unload


    window.addEventListener('beforeunload', function () {
      sessionStorage.removeItem('sdInit');
    });
  } else {
    return console.log('Cannot capture event, sd is not defined.');
  }
} //BUILD PAGE VIEW DATA


function buildPageViewData(data) {
  try {
    var getTrafficType = function getTrafficType() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);

      if (urlParams.has('gclid')) {
        return 'Paid Search';
      } else {
        return 'Organic Search';
      }
    };

    var pageType = data.pageType || getValueById("pageType") || 'Other';
    var pageViewData = {
      events: 'pageview',
      pageType: pageType,
      websiteTier: 'Tier 3',
      sessionId: getSessionId(),
      language: 'en',
      trafficType: getTrafficType(),
      siteTechnologyVersion: '2.0',
      userID: getUserId(),
      dealerZipCode: getValueById("postalCode"),
      dealerState: getValueById("state"),
      dealerCity: getValueById("city")
    };

    switch (pageType) {
      case 'Page Not Found':
        return pageViewData;
        break;

      case 'Vehicle Details':
        return _objectSpread(_objectSpread({}, pageViewData), {}, {
          pageBrand: data.manufacturer,
          dealerName: data.dealerName,
          vehicleDetails: {
            status: getValueById("condition"),
            year: getValueById("year"),
            make: getValueById("make"),
            model: getValueById("model"),
            trim: getValueById("trim"),
            engine: getValueById("engine"),
            //NEED TO ADD ENGINE
            transmission: getValueById("transmission"),
            //NEED TO ADD TRANSMISSION
            interiorColor: getValueById("interiorColor"),
            //NEED TO ADD INTERIOR COLOR
            exteriorColor: getValueById("exteriorColor"),
            vin: getValueById("vin"),
            msrp: getValueById("msrp"),
            displayedPrice: getValueById("displayedPrice"),
            fuelType: getValueById("fuel") //NEED TO ADD FUEL TYPE

          }
        });
        break;

      default:
        return _objectSpread(_objectSpread({}, pageViewData), {}, {
          pageBrand: data.manufacturer,
          dealerName: data.dealerName
        });
    }
  } catch (error) {
    throw error;
  }
} //BUILD FILTER SEARCH DATA


function buildFilterSearchData(data) {
  try {
    var getFilterSearchStatus = function getFilterSearchStatus(searchObject) {
      if (searchObject.certified && !searchObject.new) {
        return 'CPO';
      }

      if (searchObject.certified && searchObject.new || searchObject.new === 'true,false') {
        return 'Mixed';
      }

      if (searchObject.new && !searchObject.certified && searchObject.new !== 'true,false') {
        if (searchObject.new === 'true') {
          return 'New';
        }

        if (searchObject.new === 'false') {
          return 'Used';
        }
      }

      return 'Mixed';
    };

    var getFilterSearchYear = function getFilterSearchYear(searchObject) {
      if (searchObject["min-year"] === searchObject["max-year"]) {
        return searchObject["min-year"];
      }

      if (searchObject["min-year"] !== searchObject["max-year"]) {
        return "".concat(searchObject["min-year"], "-").concat(searchObject["max-year"]);
      }
    };

    returnData = {
      countSearchResults: data.countSearchResults,
      filterSearch: {
        status: getFilterSearchStatus(data.searchObject),
        year: getFilterSearchYear(data.searchObject),
        make: data.searchObject.make,
        model: data.searchObject.model,
        trim: data.searchObject.trim,
        color: data.searchObject.exteriorcolor,
        minPrice: data.searchObject["min-cost"],
        maxPrice: data.searchObject["max-cost"],
        bodyStyle: data.searchObject.bodystyle,
        features: data.searchObject.features
      },
      events: 'filterSearch'
    }; //Replace empty values with 'All', if its minPrice or maxPrice remove it

    Object.keys(returnData.filterSearch).forEach(function (key) {
      if (!returnData.filterSearch[key]) {
        returnData.filterSearch[key] = 'All';
      }

      if ((key === 'minPrice' || key === 'maxPrice') && returnData.filterSearch[key] === 'All') {
        delete returnData.filterSearch[key];
      }
    });
    return returnData;
  } catch (error) {
    throw error;
  }
} //MAIN HANDLER


function Maserati_Handler(data, options) {
  try {
    var _postData = _objectSpread({}, data);

    var sd = window.sd ? window.sd : undefined;
    var dealerCode = getValueById("dealerCode");

    if (sd && dealerCode) {
      switch (_postData.events) {
        case 'pageview':
          _postData = buildPageViewData(_postData);
          break;

        case 'filterSearch':
          _postData = buildFilterSearchData(_postData);
          break;
      }

      _postData = _objectSpread(_objectSpread({}, _postData), {}, {
        timestamp: new Date().toISOString()
      }); // remove all empty values

      _postData = Object.keys(_postData).reduce(function (acc, key) {
        if (_postData[key]) {
          acc[key] = _postData[key];
        }

        return acc;
      }, {});
      sd('dataLayer', _postData);
      sd('send', _postData.events);
      return {
        status: 'success',
        message: "Maserati Handler successfully captured event: ".concat(_postData.events),
        data: _postData
      };
    } else {
      if (!sd) return 'Cannot capture event, sd is not defined.';
      if (!dealerCode) return 'Cannot capture event, dealerCode is not found.';
    }
  } catch (error) {
    console.error(error);
    return {
      status: 'error',
      message: "Maserati Handler failed to capture event: ".concat(postData.events, " | Error: ").concat(err.message),
      data: data
    };
  }
}

module.exports = {
  Maserati_Handler: Maserati_Handler,
  MaseratiSDBSession: MaseratiSDBSession
};